<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.eventBooking')"
    namespace=""
    resource="event_bookings"
    :actionColumnProps="{ width: 160 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class EventBookings extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'event_id_eq',
        label: this.$t('eventBooking.event'),
        renderCell: {
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/events', { params: { per_page: 100 } });
              return data.map(({ id, title }) => ({ value: id, label: title }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { title_cont: keyword };
              const { data } = await this.$request.get('/events', { params });
              return data.map(item => ({ value: item.id, label: item.title }));
            }
          }
        }
      },
      {
        prop: 'user_id_eq',
        label: this.$t('eventBooking.user'),
        renderCell: {
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/users', { params: { per_page: 100 } });
              return data.map(({ id, screen_name }) => ({ value: id, label: screen_name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { title_cont: keyword };
              const { data } = await this.$request.get('/users', { params });
              return data.map(item => ({ value: item.id, label: item.screen_name }));
            }
          }
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'event',
        label: this.$t('eventBooking.event'),
        renderCell(h, { props: { value } }) {
          return <bean-link keepNode to={{ name: 'events.show', params: { id: value.id } }}>{_.get(value, 'title', value.id)}</bean-link>
        }
      },
      {
        prop: 'user',
        label: this.$t('eventBooking.user'),
        renderCell(h, { props: { value } }) {
          return <bean-link keepNode to={{ name: 'users.show', params: { id: value.id } }}>{_.get(value, 'screen_name', value.id)}</bean-link>
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'event_bookings.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'event_bookings.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/event_bookings',
    name: 'event_bookings.index',
    component: EventBookings,
    props: {
      type: 'index',
    }
  },
  {
    path: '/event_bookings/:id',
    name: 'event_bookings.show',
    component: EventBookings,
    props: {
      type: 'show',
    }
  },
]
</script>
